<template>
  <div>
    <Header :breadcrumsfirst="breadcrumsfirst" :breadcrumslast="breadcrumslast" />
    <alarmTabs />
    <div class="container">
      <div class="button-container d-flex justify-content-center align-items-center mt-4">
        <div class="form-group form-check">
          <input type="checkbox" class="form-check-input shadow-none" id="exampleCheck1" v-model="isDateRangeChecked"
            @change="emptyTableData">
          <label class="form-check-label custom-label me-4" for="exampleCheck1">Date Range</label>
        </div>

        <div class="d-flex justify-content-center align-items-center" v-if="isDateRangeChecked">
          <label for="start-date" class="custom-label me-1">Start Date:</label>
          <div class="form-group me-3">
            <input id="start-date" type="date" class="form-control shadow-none form-select-sm custom-input"
              v-model="startDate" @change="validateStartDates">
          </div>
        </div>


        <div class="d-flex justify-content-center align-items-center" v-if="isDateRangeChecked">
          <label for="start-date" class="custom-label me-1">End Date:</label>
          <div class="form-group me-3">
            <input id="end-date" type="date" class="form-control shadow-none form-select-sm custom-input"
              v-model="endDate" @change="validateEndDates">
          </div>

        </div>
        <div v-else>
          <button type="submit" class="btn btn-sm device-graph-button me-2"
            :class="{ 'active': activeTimeframe === 'Active', 'disabled': isButtonDisabled['Active'] }"
            @click="fetchData('Active', 1)" :disabled="isButtonDisabled['Active']">Active</button>
          <button type="submit" class="btn btn-sm device-graph-button me-2"
            :class="{ 'active': activeTimeframe === '1D', 'disabled': isButtonDisabled['1D'] }"
            @click="fetchData('1D', 1)" :disabled="isButtonDisabled['1D']">1D</button>
          <button type="submit" class="btn btn-sm device-graph-button me-2"
            :class="{ 'active': activeTimeframe === '1M', 'disabled': isButtonDisabled['1M'] }"
            @click="fetchData('1M', 1)" :disabled="isButtonDisabled['1M']">1M</button>
          <button type="submit" class="btn btn-sm device-graph-button me-4"
            :class="{ 'active': activeTimeframe === '1Y', 'disabled': isButtonDisabled['1Y'] }"
            @click="fetchData('1Y', 1)" :disabled="isButtonDisabled['1Y']">1Y</button>
        </div>
        <div v-if="isDateRangeChecked">
          <label for="record" class="custom-label">Records:</label>
          <div class="form-group form-check form-check-inline alarm-records-pos col-md-4">
            <input id="record" type="text" class="form-control alarm-records  shadow-none  custom-input"
              placeholder="Enter Number" v-model.number="maxlimit">
          </div>
          <span style="font-size: 10px;">(Maximum records limit: 1000)</span>

        </div>
        <div v-if="!isDateRangeChecked">
          <label for="record" class="custom-label">Records:</label>
          <div class="form-group form-check form-check-inline alarm-records-pos col-md-4">
            <input id="record" type="text" class="form-control alarm-records  shadow-none  custom-input"
              placeholder="Enter Number" v-model.number="maxlimit">
          </div>
          <span style="font-size: 10px;">(Maximum records limit: 1000)</span>

        </div>
        <button type="submit" class="btn btn-primary btn-sm generate-button generate-button-pos me-2"
          v-if="isDateRangeChecked" :disabled="isDateInvalid || isGenerateButtonDisabled"
          @click="fetchData('', 1)">Generate</button>
      </div>
      <div class="date-error-message">
        <span v-if="startDateError && isDateRangeChecked" class="text-danger me-4" style="font-size: 10px;">{{
          startDateError }}</span>
        <span v-if="endDateError && isDateRangeChecked" class="text-danger " style="font-size: 10px;">{{ endDateError
          }}</span>

      </div>
      <div class="row" :class="{
        'mt-4': (!isDateRangeChecked) || (isDateRangeChecked && !startDateError && !endDateError),
        'mt-2': (isDateRangeChecked) && (startDateError || endDateError)
      }">
        <div class="col-md-12">
          <table class="table table-responsive table-bordered custom-label">
            <thead class="table-light alarm-main-table">
              <tr>
                <th scope="col" width="15" class="alarm-no-border"></th>
                <th scope="col" colspan="4" width="300">Title / ID <br>Desc</th>
                <th scope="col" class="align-middle" width="300">Controller Name</th>
                <th scope="col" class="align-middle">Timestamp</th>
                <th scope="col" class="align-middle alarm-no-border">Severity / Status</th>
                <th scope="col" width="15"></th>
              </tr>
            </thead>
            <tbody v-for="(item, index) in tableData" :key="index">
              <tr>
                <td rowspan="4"><span class="d-flex justify-content-center align-items-center"><svg
                      xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-grid"
                      viewBox="0 0 16 16">
                      <path
                        d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5z" />
                    </svg></span></td>
                <td colspan="4"> <label class=" mb-0">{{ item.title }}</label>
                  <span class=" mb-0">(<strong>{{ item.sensorid }}</strong>)</span>
                </td>
                <td colspan="1">{{ item.sensorname }}</td>
                <td>
                  <span class="mb-0">{{ item.timestamp.trim().split('.')[0].replace('T', ' ') }}</span>
                </td>
                <td>
                  <span class="alarm-severity">{{ item.severity }}</span>
                  <span class="alarm-severity-status">{{ item.status }}</span>
                </td>
                <td rowspan="3" class="align-middle">
                  <span class="d-flex justify-content-center align-items-center">
                    <button class="alarm-custom-dropdown-icon" @click="toggleCollapse(index)">
                      <svg v-if="isCollapsed[index]" xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                        fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                          d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                      </svg>
                      <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                        class="bi bi-chevron-right" viewBox="0 0 16 16">
                        <path fill-rule="evenodd"
                          d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                      </svg>
                    </button>
                  </span>
                </td>

              </tr>
              <tr>
                <td colspan="7">
                  <p class="text-xs text-textPrimary4 mb-0 text-ellips-one">{{ item.description }}</p>
                </td>
                <!-- <td  rowspan="3">
              <span class="d-flex justify-content-end">
                <button class="alarm-custom-dropdown-icon" @click="toggleCollapse(index)"><svg
                    xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                    class="bi bi-chevron-down" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708" />
                  </svg></button>
              </span>
            </td> -->
              </tr>
              <tr>
                <!-- <td colspan="7">
              <p class="text-xs text-textPrimary4 mb-0">-</p>
            </td> -->

              </tr>
              <tr v-if="isCollapsed[index]">
                <td colspan="9" class="py-0 px-0">
                  <table class="table table-responsive alarm-sub-table mb-0">
                    <thead class="table-light">
                      <tr>
                        <th scope="col" width="120">MAC Address</th>
                        <th scope="col" width="100">Device</th>
                        <th scope="col" width="120">Sensor Type</th>
                        <th scope="col" width="90">Hub</th>
                        <th scope="col" width="90">Physical ID</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ item.macaddress }}</td>
                        <td>{{ item.deviceid }}</td>
                        <td>{{ item.sensortypeid }}</td>
                        <td>{{ item.hubid }}</td>
                        <td>{{ item.physicalid }}</td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>


          </table>
        </div>
        <div class="pagination-container">
          <div class="items-per-page">
            <label for="itemsPerPage">Records Per Page:</label>
            <select id="itemsPerPage" class="items-per-page-dropdown" v-model="pageSize" @change="changePageSize">
              <option v-for="option in pageSizeOptions" :value="option">{{ option }}</option>
            </select>
          </div>
          <div class="total-entries">
            <span>Total Records: {{ totalCount }}</span>
          </div>
          <div class="pagination">
            <ul class="pagination-list">
              <li @click="gotoPage(1)"><a><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                    fill="currentColor" class="bi bi-skip-start-fill" viewBox="0 0 16 16">
                    <path
                      d="M4 4a.5.5 0 0 1 1 0v3.248l6.267-3.636c.54-.313 1.232.066 1.232.696v7.384c0 .63-.692 1.01-1.232.697L5 8.753V12a.5.5 0 0 1-1 0z" />
                  </svg></a></li>
              <li @click="prevPage()"><a><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                    fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0" />
                  </svg></a></li>
              <li v-for="pageNumber in visiblePages" :key="pageNumber" :class="{ active: pageNumber === currentPage }"
                class="ellipsis-icon" @click="gotoPage(pageNumber)">
                <template v-if="pageNumber === 'dots'">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                      class="bi bi-three-dots" viewBox="0 0 16 16">
                      <path
                        d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3" />
                    </svg>
                  </span>
                </template>
                <template v-else>
                  <a>{{ pageNumber }}</a>
                </template>
              </li>

              <li @click="nextPage()"><a><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                    fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd"
                      d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708" />
                  </svg></a></li>
              <li @click="gotoPage(totalPages)"><a><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22"
                    fill="currentColor" class="bi bi-skip-end-fill" viewBox="0 0 16 16">
                    <path
                      d="M12.5 4a.5.5 0 0 0-1 0v3.248L5.233 3.612C4.693 3.3 4 3.678 4 4.308v7.384c0 .63.692 1.01 1.233.697L11.5 8.753V12a.5.5 0 0 0 1 0z" />
                  </svg></a></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import alarmTabs from '@/components/alarm-tabs.vue';
import { getProcessAlarm } from "@/http/dashboard/alarm.http"
export default {
  name: 'process',
  components: {
    Header,
    alarmTabs
  },
  data() {
    return {
      breadcrumsfirst: "Dashboard",
      breadcrumslast: "Alarms",
      maxlimit: 100,
      maxLimitSave: 0,
      tableData: [],
      isCollapsed: [],
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      pageSizeOptions: [10, 20],
      isDateRangeChecked: 0,
      minStartDate: '',
      maxStartDate: '',
      startDate: '',
      startDateError: '',
      minEndDate: '',
      maxEndDate: '',
      endDate: '',
      endDateError: '',
      timeFrameGbl: '',
      activeTimeframe: 'Active',
    }
  },
  mounted() {
    const currentDate = new Date(); // Get current date
    const currentYear = currentDate.getFullYear(); // Get current year
    const currentMonth = currentDate.getMonth() + 1; // Get current month (Month is zero-based)
    const currentDay = currentDate.getDate(); // Get current day

    // Construct min and max dates
    this.minStartDate = `${currentYear - 1}-${currentMonth.toString().padStart(2, '0')}-${currentDay.toString().padStart(2, '0')}`;
    this.maxStartDate = `${currentYear}-${currentMonth.toString().padStart(2, '0')}-${currentDay.toString().padStart(2, '0')}`;
    this.minEndDate = `${currentYear - 1}-${currentMonth.toString().padStart(2, '0')}-${currentDay.toString().padStart(2, '0')}`;
    this.maxEndDate = `${currentYear}-${currentMonth.toString().padStart(2, '0')}-${currentDay.toString().padStart(2, '0')}`;
    this.fetchData('Active', 1);
  },
  created() {
    // Initialize isCollapsed with the correct length and set all elements to false
    this.isCollapsed = new Array(this.tableData.length).fill(false);
  },
  methods: {
    fetchData(timeframe, clickMode) {
      if (this.activeTimeframe !== timeframe) {
        this.currentPage = 1;
      }
      let payload = {}
      this.activeTimeframe = timeframe;
      if (clickMode === 1) {
        this.currentPage = 1;
        this.maxLimitSave = this.maxlimit
        payload = {
          index: this.currentPage,
          pagesize: this.pageSize,
          maxlimit: this.maxlimit
        }
      } else {
        payload = {
          index: this.currentPage,
          pagesize: this.pageSize,
          maxlimit: this.maxLimitSave
        }
      }
      // Check if date range checkbox is selected
      if (this.isDateRangeChecked) {
        // If selected, include start date and end date in the payload
        payload.startdate = this.startDate;
        payload.enddate = this.endDate;
      } else {
        // If not selected, include timeframe in the payload
        if (timeframe !== "") {
          payload.timeframe = timeframe;
          this.timeFrameGbl = timeframe;

        } else {
          payload.timeframe = this.timeFrameGbl
        }
      }
      getProcessAlarm(payload)
        .then(response => {
          this.tableData = response.data;
          this.totalCount = response.recordcount.totalcount;
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    },
    emptyTableData() {
      if (this.isDateRangeChecked) {
        this.tableData = [],
          this.totalCount = 0,
          this.startDate = '',
          this.endDate = '',
          this.startDateError = '',
          this.endDateError = '',
          this.maxlimit = 100
      } else {
        this.tableData = [],
        this.totalCount = 0,
         this.maxlimit = 100,
        this.fetchData('Active', 1)
       
      }
    },
    gotoPage(pageNumber) {
      if (pageNumber >= 1 && pageNumber <= this.totalPages) {
        this.currentPage = pageNumber;
        this.fetchData(this.timeFrameGbl, 0);
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchData(this.timeFrameGbl, 0);
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchData(this.timeFrameGbl, 0);
      }
    },
    changePageSize() {
      this.currentPage = 1; // Reset to the first page when changing page size
      this.fetchData(this.timeFrameGbl, 0);
    },
    toggleCollapse(index) {
      this.isCollapsed[index] = !this.isCollapsed[index];
    },
    validateStartDates() {
      if (this.startDate && this.startDate < this.minStartDate) {
        this.startDateError = 'select start date after ' + this.minStartDate;
        this.startDate = ''; // Clear the invalid date
      } else if (this.startDate && this.startDate > this.maxStartDate) {
        this.startDateError = 'select start date before ' + this.maxStartDate;
        this.startDate = ''; // Clear the invalid date
      } else {
        this.startDateError = '';
      }
    },
    validateEndDates() {
      if (this.endDate && this.endDate < this.minEndDate) {
        this.endDateError = 'select end date after ' + this.minEndDate;
        this.endDate = ''; // Clear the invalid date
      } else if (this.endDate && this.endDate > this.maxEndDate) {
        this.endDateError = 'select end date before ' + this.maxEndDate;
        this.endDate = ''; // Clear the invalid date
      } else {
        this.endDateError = '';
      }
    }
  },
  computed: {
    isDateInvalid() {
      return this.startDateError !== '' || this.endDateError !== '';
    },
    isGenerateButtonDisabled() {
      return (
        !this.startDate ||
        !this.endDate ||
        this.maxlimit > 1000 ||
        !this.maxlimit
      );
    },
    isButtonDisabled() {
      return {
        'Active': this.maxlimit > 1000 || !this.maxlimit,
        '1D': this.maxlimit > 1000 || !this.maxlimit,
        '1M': this.maxlimit > 1000 || !this.maxlimit,
        '1Y': this.maxlimit > 1000 || !this.maxlimit,
      };
    },
    totalPages() {
      return Math.ceil(this.totalCount / this.pageSize);
    },
    visiblePages() {
      const totalVisiblePages = 3; // Change this as needed
      const pages = [];
      let startPage = 1;
      let endPage = this.totalPages;

      if (this.totalPages > totalVisiblePages) {
        const halfVisiblePages = Math.floor(totalVisiblePages / 2);
        startPage = Math.max(this.currentPage - halfVisiblePages, 1);
        endPage = startPage + totalVisiblePages - 1;

        if (endPage > this.totalPages) {
          startPage -= endPage - this.totalPages;
          endPage = this.totalPages;
        }

        if (startPage > 1) {
          pages.push(1);
          if (startPage > 2) {
            pages.push('dots');
          }
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }

      if (endPage < this.totalPages) {
        if (endPage < this.totalPages - 1) {
          pages.push('dots');
        }
        pages.push(this.totalPages);
      }

      return pages;
    }
  },


}
</script>

<style scoped>
.table th {
  background-color: #f1f2f4;
}

.alarm-records {
  padding-top: 3.5px;
  padding-bottom: 3.5px;
}

.alarm-records-pos {
  padding-left: 8px;
}

.device-graph-button.disabled {
  cursor: not-allowed;
  opacity: 0.3;
}

.date-error-message {
  margin-left: 245px;
}

.generate-button-pos {
  margin-left: -30px;
}
</style>